import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";

import AnalyticsHeader from "./partials/analytics-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import RecurringPassAnalyticsTable from "./partials/recurring-pass-analytics-table.jsx";
import LinkLike from "./partials/link-like.jsx";

import Select from "react-select";
import cloneDeep from "lodash/cloneDeep";

class RecurringPassAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      renewalWarningPeriod: 14,
      expiredPassTimePeriod: 90,
      newSubscriptionTimePeriod: 90
    };
  }

  static getStores() {
    return [EventBucketStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getRecurringPassAnalytics: AnalyticsStore.getRecurringPassAnalytics,
      getExpiredPassAnalytics: AnalyticsStore.getExpiredPassAnalytics,
      getNewSubscriptionAnalytics: AnalyticsStore.getNewSubscriptionAnalytics,
      getIsFetchingRenewalAnalytics:
        AnalyticsStore.getIsFetchingRenewalAnalytics,
      getIsFetchingExpiredPassAnalytics:
        AnalyticsStore.getIsFetchingExpiredPassAnalytics,
      getIsFetchingNewSubscriptionAnalytics:
        AnalyticsStore.getIsFetchingNewSubscriptionAnalytics
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props, "all");
  }

  componentWillReceiveProps(newProps, force = null) {
    if (
      force === "all" ||
      newProps.params.eventBucketId !== this.props.params.eventBucketId
    ) {
      const eventBucketId = newProps.params.eventBucketId;
      const renewalWarningPeriod = this.state.renewalWarningPeriod;
      const expiredPassTimePeriod = this.state.expiredPassTimePeriod;
      const newSubscriptionTimePeriod = this.state.newSubscriptionTimePeriod;
      AnalyticsActions.fetchRecurringPassAnalytics.defer({
        eventBucketId,
        renewalWarningPeriod
      });
      AnalyticsActions.fetchExpiredPassAnalytics.defer({
        eventBucketId,
        expiredPassTimePeriod
      });
      AnalyticsActions.fetchNewSubscriptionAnalytics.defer({
        eventBucketId,
        newSubscriptionTimePeriod
      });
      EventBucketActions.fetchOne.defer(newProps.params.eventBucketId);
    } else if (force) {
      const eventBucketId = newProps.params.eventBucketId;
      if (force === "renewals") {
        const renewalWarningPeriod = this.state.renewalWarningPeriod;
        AnalyticsActions.fetchRecurringPassAnalytics.defer({
          eventBucketId,
          renewalWarningPeriod
        });
      } else if (force === "expired_passes") {
        const expiredPassTimePeriod = this.state.expiredPassTimePeriod;
        AnalyticsActions.fetchExpiredPassAnalytics.defer({
          eventBucketId,
          expiredPassTimePeriod
        });
      } else if (force === "new_subscriptions") {
        const newSubscriptionTimePeriod = this.state.newSubscriptionTimePeriod;
        AnalyticsActions.fetchNewSubscriptionAnalytics.defer({
          eventBucketId,
          newSubscriptionTimePeriod
        });
      }
    }
  }

  render() {
    const { eventBucketId } = this.props.params,
      eventBucket = this.props.getEventBucketById(eventBucketId),
      recurringPassAnalytics = this.props.getRecurringPassAnalytics(
        eventBucketId
      ),
      expiredPassAnalytics = this.props.getExpiredPassAnalytics(eventBucketId),
      newSubscriptionAnalytics = this.props.getNewSubscriptionAnalytics(
        eventBucketId
      );

    if (
      !(
        recurringPassAnalytics &&
        expiredPassAnalytics &&
        newSubscriptionAnalytics
      ) ||
      !eventBucket
    ) {
      return <WorkingIndicator fullPage={true} />;
    }

    let processedRenewalData = [];
    for (let y = 0; y < recurringPassAnalytics.data.length; y++) {
      const thisPassSub = recurringPassAnalytics.data[y];
      for (let z = 0; z < thisPassSub.passes.length; z++) {
        let singlePassSub = cloneDeep(thisPassSub);
        singlePassSub.pass = thisPassSub.passes[z];
        processedRenewalData.push(singlePassSub);
      }
    }

    let processedExpiredData = [];
    for (let y = 0; y < expiredPassAnalytics.data.length; y++) {
      const thisPassSub = expiredPassAnalytics.data[y];
      for (let z = 0; z < thisPassSub.passes.length; z++) {
        let singlePassSub = cloneDeep(thisPassSub);
        singlePassSub.pass = thisPassSub.passes[z];
        processedExpiredData.push(singlePassSub);
      }
    }

    let processedNewSubscriptionData = [];
    for (let y = 0; y < newSubscriptionAnalytics.data.length; y++) {
      const thisPassSub = newSubscriptionAnalytics.data[y];
      for (let z = 0; z < thisPassSub.passes.length; z++) {
        let singlePassSub = cloneDeep(thisPassSub);
        singlePassSub.pass = thisPassSub.passes[z];
        processedNewSubscriptionData.push(singlePassSub);
      }
    }

    return (
      <div>
        <AnalyticsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label="recurring pass analytics"
          subpath="recurring_pass"
        />
        {this.props.getIsFetchingRenewalAnalytics() ? (
          <div style={{ width: 100, height: 100, marginTop: 20 }}>
            <WorkingIndicator />
          </div>
        ) : (
          <div>
            <div
              style={{
                marginTop: "1em",
                marginBottom: "0.5em",
                fontWeight: "bold",
                fontSize: 18
              }}
            >
              <div
                className="pull-left"
                style={{ paddingTop: 8, paddingRight: 10 }}
              >
                Recurring passes renewing or expiring in the next
              </div>
              <div className="pull-left">
                <Select
                  style={{ width: "150px", marginBottom: 10 }}
                  clearable={false}
                  autosize={false}
                  multi={false}
                  value={this.state.renewalWarningPeriod}
                  options={[
                    { label: "14 days", value: 14 },
                    { label: "30 days", value: 30 },
                    { label: "60 days", value: 60 },
                    { label: "90 days", value: 90 }
                  ]}
                  onChange={e => {
                    this.setState({ renewalWarningPeriod: e.value }, () => {
                      this.componentWillReceiveProps(this.props, "renewals");
                    });
                  }}
                />
              </div>
            </div>
            <RecurringPassAnalyticsTable
              reportName="Renewing or Expiring Passes"
              eventBucket={eventBucket}
              data={processedRenewalData}
              includeAutorenew={true}
              includeCardOnFile={true}
              includeExpiredDate={false}
              includeRenewalDate={true}
            />
          </div>
        )}

        {this.props.getIsFetchingExpiredPassAnalytics() ? (
          <div style={{ width: 100, height: 100, marginTop: 20 }}>
            <WorkingIndicator />
          </div>
        ) : (
          <div>
            <div
              style={{
                marginTop: "1em",
                marginBottom: "0.5em",
                fontWeight: "bold",
                fontSize: 18
              }}
            >
              <div
                className="pull-left"
                style={{ paddingTop: 8, paddingRight: 10 }}
              >
                Expired passes in the past
              </div>
              <div className="pull-left">
                <Select
                  style={{ width: "150px", marginBottom: 10 }}
                  clearable={false}
                  autosize={false}
                  multi={false}
                  value={this.state.expiredPassTimePeriod}
                  options={[
                    { label: "90 days", value: 90 },
                    { label: "1 year", value: 365 },
                    { label: "2 years", value: 730 },
                    { label: "3 years", value: 1095 }
                  ]}
                  onChange={e => {
                    this.setState({ expiredPassTimePeriod: e.value }, () => {
                      this.componentWillReceiveProps(
                        this.props,
                        "expired_passes"
                      );
                    });
                  }}
                />
              </div>
            </div>
            <RecurringPassAnalyticsTable
              reportName="Expired Passes"
              eventBucket={eventBucket}
              data={processedExpiredData}
              includeAutorenew={false}
              includeCardOnFile={false}
              includeExpiredDate={true}
              includeRenewalDate={false}
            />
          </div>
        )}

        {this.props.getIsFetchingNewSubscriptionAnalytics() ? (
          <div style={{ width: 100, height: 100, marginTop: 20 }}>
            <WorkingIndicator />
          </div>
        ) : (
          <div>
            <div
              style={{
                marginTop: "1em",
                marginBottom: "0.5em",
                fontWeight: "bold",
                fontSize: 18
              }}
            >
              <div
                className="pull-left"
                style={{ paddingTop: 8, paddingRight: 10 }}
              >
                New subscriptions in the past
              </div>
              <div className="pull-left">
                <Select
                  style={{ width: "150px", marginBottom: 10 }}
                  clearable={false}
                  autosize={false}
                  multi={false}
                  value={this.state.newSubscriptionTimePeriod}
                  options={[
                    { label: "90 days", value: 90 },
                    { label: "1 year", value: 365 },
                    { label: "2 years", value: 730 },
                    { label: "3 years", value: 1095 }
                  ]}
                  onChange={e => {
                    this.setState(
                      { newSubscriptionTimePeriod: e.value },
                      () => {
                        this.componentWillReceiveProps(
                          this.props,
                          "new_subscriptions"
                        );
                      }
                    );
                  }}
                />
              </div>
            </div>
            <RecurringPassAnalyticsTable
              reportName="New Subscriptions"
              eventBucket={eventBucket}
              data={processedNewSubscriptionData}
              includeAutorenew={true}
              includeCardOnFile={true}
              includeExpiredDate={false}
              includeRenewalDate={true}
            />
          </div>
        )}
      </div>
    );
  }
}

export default connectToStores(RecurringPassAnalytics);



// WEBPACK FOOTER //
// ./src/app/components/recurring-pass-analytics.jsx